import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'start',
    padding: '0px',
    margin: '20px 80px',
    fontStyle: 'normal',
  },
  listActionContainer: {
    marginBottom: '10px',
  },
  block: {
    textAlign: 'center',
    margin: '25px 0',
    width: '50rem',
  },
  form: {
    width: '100%',
  },
  contentFormWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  ticketSubject: {
    width: '100%',
  },
  inputSubjectWrapper: {
    padding: 0,
  },
  button: {
    '&:last-child': {
      marginLeft: '1.875rem',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2.5rem',
  },
  plusIcon: {
    fill: theme.palette.info.main,
    marginRight: '0.5rem',
  },
  openTextDecorator: {
    marginTop: '8px',

    fontStyle: 'normal',
  },
  header: {
    fontStyle: 'normal',
    marginBottom: '1rem',
  },
  description: {
    fontFamily: 'Montserrat',
    marginLeft: '10px',
    marginTop: '5px',
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  inputWithAutocomplete: {
    '& .MuiFormHelperText-root': {
      marginTop: '-2px',
      width: 'fit-content',
      alignSelf: 'flex-end',
    },
  },
  isScheduledButtons: { paddingTop: '8px' },
  section: {
    borderBottom: `2px solid ${theme.palette.grey[400]}`,
    paddingBottom: '16px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
  },
  phoneNumbersHeader: {
    display: 'flex',
  },
  phoneNumbersWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    marginTop: '20px',
  },
  phoneNumbersContainer: {
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '6px 8px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-5px',
    gap: '5px',
  },
  errorMessage: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    marginTop: '4px',
    marginLeft: '30px',
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  sectionDescription: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  fieldGroup: {
    marginBottom: theme.spacing(4),
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  inputWithTemplateWrapper: {
    display: 'flex',
    alignItems: 'start',
    gap: '2px',
  },
}));

export default useStyles;
